export class WhiteListDTO{
    constructor(
        public ip: string,
        public token: string
    ){}
}